module.exports = __webpack_public_path__ + "static/flags/TH-d538463f456b40c1885a5558b2eb2dcc.gif";